import { styled } from '@linaria/react';

export const Wrapper = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	width: 100%;
	height: 100%;
	overflow: hidden;
	mask-image: linear-gradient(
		180deg,
		transparent 5%,
		rgba(0, 0, 0, 1) 15%,
		rgba(0, 0, 0, 1) 85%,
		transparent 95%
	);

	&:after {
		content: '';
		position: absolute;
		left: 10%;
		top: 42%;
		width: 80%;
		height: 16%;
		background: linear-gradient(
			180deg,
			rgb(228.44, 59.01, 174.69) 0%,
			rgb(0, 122.26, 255) 100%
		);
		border-radius: 5px;
		filter: blur(7px);
	}
`;

export const Particles = styled.div`
	--index: calc(var(--i) + 1);
	margin-left: calc((var(--index) * 5px) * -1);
	width: calc(var(--index) * 0.55px);
	height: calc(var(--index) * 0.55px);
	box-shadow: 152px 21px #fff, 89px 14px #fff, 24px 14px #fff, 125px 4px #fff,
		128px 26px #fff, 86px 30px #fff, 57px 20px #fff, 138px 31px #fff,
		65px 28px #fff, 31px 17px #fff, 38px 21px #fff, 140px 9px #fff,
		18px 6px #fff, 91px 29px #fff, 102px 10px #fff, 82px 23px #fff,
		128px 13px #fff, 114px 33px #fff, 153px 37px #fff, 40px 28px #fff,
		154px 19px #fff, 149px 15px #fff, 41px 7px #fff, 105px 26px #fff,
		42px 26px #fff, 145px 27px #fff, 84px 19px #fff, 108px 34px #fff,
		73px 15px #fff, 90px 10px #fff, 48px 30px #fff, 108px 3px #fff,
		122px 36px #fff, 111px 5px #fff, 55px 4px #fff, 51px 16px #fff,
		28px 3px #fff, 100px 4px #fff, 74px 31px #fff, 62px 26px #fff,
		30px 11px #fff, 75px 33px #fff, 47px 4px #fff, 119px 5px #fff,
		151px 23px #fff, 95px 7px #fff, 56px 33px #fff, 86px 6px #fff;
	animation: move1 calc(var(--index) * 2s) linear infinite;

	&:after {
		content: '';
		position: absolute;
		top: -40px;
		width: inherit;
		height: inherit;
		box-shadow: inherit;
	}

	@keyframes move1 {
		from {
			transform: translateY(0px);
		}
		to {
			transform: translateY(-40px);
		}
	}
`;
